import Image from 'react-bootstrap/Image';
import logo from '../assets/images/bee.png';

function Home() {
  return <div className='col d-flex align-items-center justify-content-center mt-5'><Image className='' src={logo} fluid /></div>;
}

export default Home;
